import Navbar from "../../components/navbar/Navbar"
function NotFound(){
   
    return(
        
        <div>
             <Navbar title="سایت عوض نیا" />
            <h1>404</h1>
        </div>
    )
}
export default NotFound